module.exports = __webpack_public_path__ + "img/Fire_Potion.1514ec4f.png";